export default {
      id: "arrows-right-usage",
      viewBox: "0 0 32 32",
      url: "assets/" + "sprite.svg#arrows-right-usage",
      toString: function () {
        return this.url;
      }
    }